module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.b0bbe6ae.png";